import React from 'react';
import './CustomQuestBox.css';
import BackRacImage from '../../assets/images/rectangle.png';
import CustomPrimaryButton from './CustomPrimaryButton';
import { BiNotepad } from 'react-icons/bi';
import { MdStars } from 'react-icons/md';
import { IoIosLock } from 'react-icons/io';

function CustomQuestBox({ isLocked, isLeaderBoard, classNameQuest, quest, handleClick, questionsCount }) {
  return (
    <div className={`custom-quest-box-parent container-fluid ${classNameQuest}`}>
      <div className='custom-quest-box'>
        <div className='quest-business color-014598'>
          <span><BiNotepad /></span>
          <h6 className='text-white'>{quest?.title || 'Quest Title'}</h6>
          <img src={BackRacImage} alt="Background" />
        </div>
        <div className='quest-business color-014598 rounded level-quest'>
          <h6 className='text-white'>{quest?.difficulty || 'Easy'}</h6>
        </div>
        <div className={`quest-business rounded ${isLocked ? 'color-4D4D4D' : 'color-014598'}`}>
          <h6 className='text-white'>{isLocked ? 'Locked' : 'In progress'}</h6>
        </div>
      </div>

      <div className='row g-5 align-items-stretch'>
        <div className='col-md-8 col-sm-12 mb-2 d-flex'>
          <h6 className='text-white custom-border color-014598 h-100 w-100 custom-quest-heading rounded'>
            {quest?.description?.replace(/<\/?[^>]+(>|$)/g, '') || 'Complete tasks to progress.'}
          </h6>
        </div>
        <div className='col-md-4 col-sm-12 mb-2 d-flex justify-content-center'>
          <div className='color-014598 custom-border h-100 w-100 rounded text-center d-flex flex-column justify-content-center align-items-center p-3'>
            <h6 className='text-warning'>Reward</h6>
            <p className='text-warning d-flex align-items-center justify-content-center'>
              <MdStars /> {quest?.reward || 20}
            </p>
          </div>
        </div>
      </div>

      <div className='row g-5'>
        <div className={`${isLeaderBoard ? 'col-md-12' : 'col-md-12'} col-sm-12 mb-2`}>
          <h6 className='text-warning custom-border color-014598 h-100 custom-quest-heading rounded text-center'>
            {questionsCount}
          </h6>
        </div>
      </div>

      <div className='row g-5'>
        <div className='col-md-12 col-sm-12 mb-2'>
          <CustomPrimaryButton
            icon={isLocked ? <IoIosLock size={25} /> : ''}
            btnTextPro={isLocked ? "Locked" : "Start"}
            classNamePro={isLocked ? "btn-custom-quest locked" : "btn-custom-quest"}
            customWelcomeClass={isLocked ? "custom-quest-class locked" : "custom-quest-class"}
            handleOnClick={handleClick}
            style={{ pointerEvents: isLocked ? 'none' : 'auto' }}
          />
        </div>
      </div>
    </div>
  );
}

export default CustomQuestBox;
